// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicinaRadaContainer_wrapper__muPSh {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 44px;
  column-gap: 88px;
  padding: 90px;
  background-color: #f7f7f7;
  border-radius: 16px;
  width: 90%;
}

.MedicinaRadaContainer_link__lpLLy {
  text-decoration: none;
}

@media screen and (max-width: 1560px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    grid-template-columns: repeat(3, 1fr);
    width: 88%;
  }
}

@media screen and (max-width: 1280px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    padding-left: 30px;
    margin-left: 5%;
  }
}

@media screen and (max-width: 1150px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    margin-left: 5%;
  }
}

@media screen and (max-width: 1120px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    grid-template-columns: repeat(2, 1fr);
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 40px;
  }
}

@media screen and (max-width: 850px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    padding-top: 40px;
    column-gap: 20px;
    width: 80%;
  }
}

@media screen and (max-width: 750px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    margin-left: 10%;
  }
}
@media screen and (max-width: 740px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    margin-left: 1%;
  }
}

@media screen and (max-width: 700px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    margin-left: 30px;
    width: 80%;
    padding-left: 10px;
  }
}

@media screen and (max-width: 670px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    width: 75%;
    margin-left: 25px;
  }
}

@media screen and (max-width: 520px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    width: 80%;
    margin-left: 0;
  }
}

@media screen and (max-width: 433px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    column-gap: 5%;
    padding-left: 5%;
    width: 80%;
  }
}

@media screen and (max-width: 380px) {
  .MedicinaRadaContainer_wrapper__muPSh {
    column-gap: 0;
    width: 80%;
    padding-left: 4%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MedicinaRada/MedicinaRadaContainer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  row-gap: 44px;\n  column-gap: 88px;\n  padding: 90px;\n  background-color: #f7f7f7;\n  border-radius: 16px;\n  width: 90%;\n}\n\n.link {\n  text-decoration: none;\n}\n\n@media screen and (max-width: 1560px) {\n  .wrapper {\n    grid-template-columns: repeat(3, 1fr);\n    width: 88%;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .wrapper {\n    padding-left: 30px;\n    margin-left: 5%;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  .wrapper {\n    margin-left: 5%;\n  }\n}\n\n@media screen and (max-width: 1120px) {\n  .wrapper {\n    grid-template-columns: repeat(2, 1fr);\n    width: fit-content;\n    padding-left: 40px;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .wrapper {\n    padding-top: 40px;\n    column-gap: 20px;\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .wrapper {\n    margin-left: 10%;\n  }\n}\n@media screen and (max-width: 740px) {\n  .wrapper {\n    margin-left: 1%;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .wrapper {\n    margin-left: 30px;\n    width: 80%;\n    padding-left: 10px;\n  }\n}\n\n@media screen and (max-width: 670px) {\n  .wrapper {\n    width: 75%;\n    margin-left: 25px;\n  }\n}\n\n@media screen and (max-width: 520px) {\n  .wrapper {\n    width: 80%;\n    margin-left: 0;\n  }\n}\n\n@media screen and (max-width: 433px) {\n  .wrapper {\n    column-gap: 5%;\n    padding-left: 5%;\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .wrapper {\n    column-gap: 0;\n    width: 80%;\n    padding-left: 4%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MedicinaRadaContainer_wrapper__muPSh`,
	"link": `MedicinaRadaContainer_link__lpLLy`
};
export default ___CSS_LOADER_EXPORT___;
